/**
 * Core domain vocabulary shared by every layer.
 * Anything here is a CONTRACT: renaming a value is a breaking change.
 */
export const SIGILS = [
    "fox", "raven", "stag", "owl", "wolf", "hare", "boar", "serpent",
    "falcon", "badger", "moth", "heron", "bear", "lynx", "crow", "toad",
];
export const CLOAKS = [
    "crimson", "emerald", "midnight", "gold", "plum", "ash",
    "forest", "copper", "ivory", "storm", "rose", "obsidian",
];
export const GAME_MODES = ["living-room", "split-castle", "scattered"];
/**
 * Every phase of a castle, in the order a day usually runs. The flow between
 * them is data (packages/core/src/game/flow.ts), not hard-coded logic.
 */
export const PHASES = [
    "lobby",
    "role-reveal",
    /** Before the first mission: Welcome Drinks, a chance to size each other up. */
    "gathering",
    "breakfast",
    "mission",
    /** Sometimes, after a mission: a chance to win a Shield, decided on each phone. */
    "shield",
    "diaries",
    "round-table",
    /** Votes are cast and revealed one by one. A tie leads to a revote. */
    "vote",
    /** The banished player's last words and role reveal. */
    "banishment",
    "night",
    /** Four or fewer remain: end the game, or banish again? */
    "endgame",
    /** The game is over and the winners are crowned. */
    "finale",
];
export const ROLES = ["faithful", "traitor"];
/** Player state in the castle. Portraits are eliminated players in The Gallery. */
export const PLAYER_STATUSES = ["alive", "murdered", "banished"];
/** Video diaries (spec: 10–15 second confessionals). */
export const DIARY = {
    maxMs: 15_000,
    minMs: 2_000,
    /** Generous: 15 s of 720p at ~2 Mbps is ~4 MB. */
    maxBytes: 30 * 1024 * 1024,
    /** Diaries played on the TV at each Round Table. */
    featuredPerRound: 3,
    /** Guests sent to the diary room each day. */
    perDay: 2,
    /** Media is deleted this long after the castle closes (spec: privacy). */
    retentionMs: 24 * 60 * 60 * 1000,
};
/** Upload types we accept. iPhones record MP4/QuickTime; Android and desktop Chrome record WebM. */
export const DIARY_MEDIA_TYPES = [
    "video/webm",
    "video/mp4",
    "video/quicktime",
    "audio/webm",
    "audio/mp4",
    "audio/ogg",
];
export const LIMITS = {
    minPlayers: 6,
    maxPlayers: 16,
    nameMaxLength: 16,
    /** How long a dropped phone keeps its seat. */
    seatHoldMs: 3 * 60 * 1000,
    /** How long an idle castle lives before it is cleaned up. */
    castleTtlMs: 4 * 60 * 60 * 1000,
};
/**
 * As in the show: two Traitors for most castles, three for the biggest (16).
 * Small castles (6–7) get one, or the Traitors win before the game gets going.
 */
export function traitorCountFor(playerCount) {
    if (playerCount >= 16)
        return 3;
    if (playerCount >= 8)
        return 2;
    return 1;
}
/** Fewer than this and the game is short and thin: we suggest filling seats (computer guests on the test site). */
export const SUGGESTED_PLAYERS = 8;
//# sourceMappingURL=domain.js.map